// extracted by mini-css-extract-plugin
export default {"mainLeft":"Outpost_mainLeft__fQOt1","rightSidebar":"Outpost_rightSidebar__CrI0r"};